import { call, put, takeEvery } from 'redux-saga/effects';
import { saveAs } from 'file-saver';
import { sagaActions } from './sagaActions';
import { Uchain } from '../redux/api/agent';
import { updatePreSignedUrls, updateImsReceiptsData, updateError, updateADFATReport, updateCarrierList, updateLoader, updateTruckUnloadSummaryList, updateVendorList, updateTruckUnloadStatsList, updateScheduledLoadStatusList, updateSelectedReport, updateADFATReportResponse, clearTruckUnloadSummaryList, clearTruckUnloadStatsList, updateOperationObj, updateGateCheckReportList, clearGateCheckReportList } from '../redux/reducers/reducerSlices/ReportsReducerSlice';
import { showAlert } from '../App/Assests/Utility';
import { toast } from 'react-toastify';

function* getTruckReportAndReceiptDetailsSaga(action) {
    try {
        const {sendEmail} = action?.payload;
        yield put(updateLoader(true));
        const response = yield call(Uchain.getTruckReportAndReceiptDetails, action.payload);
        if (sendEmail) {
            yield put(updateOperationObj({
                type: 'receipt',
                response: response
            }))

        } else {
            yield put(updateImsReceiptsData(response));
        }

    } catch (error) {
        yield put(updateError(true));
        yield put(updateOperationObj({}))
    } finally {
        yield put(updateLoader(false));
        // yield put(updateError(false));
    }
}

function* updateTruckUnloadSummarySaga(data) {
    try {
        // yield put(updateLoader(true));
        const response = yield call(Uchain.getTruckUnloadSummary, data.payload);
        // yield put(updateTruckUnloadSummaryList(response));

        if (!response || response.length === 0) {
            yield put(updateTruckUnloadSummaryList([]));
            yield put(updateLoader(false));
        } else {
            yield put(updateTruckUnloadSummaryList(response));
        }
    } catch {
        yield put(updateTruckUnloadSummaryList([]));
        yield put(updateLoader(false))
    }
}

function* updateADFATSaga(data){
    try {
        const response = yield call(Uchain.adfatReport, data.payload)
        yield put(updateADFATReportResponse(response))
    } catch (error) {
        yield put(updateLoader(false))
    }
}

function* updateIntiateLoaderSaga(data){
    try {
        yield put(updateLoader(data.payload))
    } catch (error) {
        
    }
}

function* updateCarrierListSaga(data){
    try {
        const response = yield call(Uchain.getCarrier, data.payload);
        yield put(updateCarrierList(response))
    } catch (error) {
        
    }
}

function* updateVendorListSaga(data){
    try {
        const response = yield call(Uchain.getVendor, data.payload);
        yield put(updateVendorList(response))
    } catch (error) {
        
    }
}
function* updateTruckUnloadStatsSaga(data) {
    try {
        const response = yield call(Uchain.getTruckUnloadStats, data.payload);        
        // yield put(updateTruckUnloadStatsList(response));

         if (!response || response.length === 0) {
            yield put(updateTruckUnloadStatsList([]));
            yield put(updateLoader(false));
        } else {
            yield put(updateTruckUnloadStatsList(response));
        }
    }
    catch{
        yield put(updateTruckUnloadStatsList([]));
            yield put(updateLoader(false));
    }
}

function* updateScheduledLoadStatusSaga(data) {
    try {
        const response = yield call(Uchain.getScheduledLoadStatus, data.payload);    
        // yield put(updateScheduledLoadStatusList(response));
        if (!response || response.length === 0) {
            yield put(updateScheduledLoadStatusList([]));
            yield put(updateLoader(false));
        } else {
            yield put(updateScheduledLoadStatusList(response));
        }
    }
    catch{
        yield put(updateScheduledLoadStatusList([]));
        yield put(updateLoader(false))
    }
}

function* updateGateCheckReportSaga(data) {
    try {
        const response = yield call(Uchain.getGateCheckReport, data.payload);
        // yield put(updateGateCheckReportList(response));
        if (!response || response.length === 0) {
            yield put(updateGateCheckReportList([]));
            yield put(updateLoader(false));
        } else {
            yield put(updateGateCheckReportList(response));
        }
    }
    catch{
        yield put(updateGateCheckReportList([]));
        yield put(updateLoader(false))
    }
}

function* updateSelectedReportSaga(data){
    try {
        yield put(updateSelectedReport(data.payload));
    } catch (error) {
    }
}

function* clearADFATSaga(){
    try {
        yield put(updateADFATReport([]))
        yield put(updateADFATReportResponse([]));
        yield put(updateLoader(false))
    } catch (error) {
    }
}

function* clearTruckUnloadSummarySaga(){
    try {
        yield put(clearTruckUnloadSummaryList([]))
        // yield put(updateLoader(false))
    } catch (error) {
    }
}

function* clearTruckUnloadStatsSaga(){
    try {
        yield put(clearTruckUnloadStatsList([]))
        // yield put(updateLoader(false))
    } catch (error) {
    }
}

function* clearGateCheckReportSaga(){
    try {
        yield put(clearGateCheckReportList())
    } catch (error) {
    }
}

function* truckReportOperationObjSaga(action){
    try {
        yield put(updateOperationObj(action.payload))
    } catch (error) {
        yield put(updateOperationObj({}))
    }
}

function* downloadTruckReceiptZipSaga(action) {
    try {
        const response = yield call(Uchain.downloadTruckReciptzip, action.payload);
        if (action.callback) {
            action.callback({ success: true, data: response });
        }
    } catch (error) {
        if (action.callback) {
            action.callback({ success: false, error });
        }
        // showAlert(toast.TYPE.ERROR, `Something went wrong while downloading the images. Please try again later or check your network connection.`, 'light')
    }
}

function* clearTruckReportErrorSaga(){
    try {
        yield put(updateError(false))
    } catch (error) {
        yield put(updateError(false))
    }
}

export function* downloadTruckReceiptZipWatcher() {
    yield takeEvery(sagaActions.DOWNLOAD_TRUCK_RECEIPT_ZIP, downloadTruckReceiptZipSaga);
}
export function* updateADFATWatcher() {
    yield takeEvery(sagaActions.GET_ADFAT_REPORT_LIST, updateADFATSaga)
}
export function* intiateLoaderWatcher() {
    yield takeEvery(sagaActions.INTIATE_LOADER_REPORTS, updateIntiateLoaderSaga)
}   
export function* updateCarrierListWatcher() {
    yield takeEvery(sagaActions.GET_CARRIER_LIST, updateCarrierListSaga)
}
export function* updateVendorListWatcher() {
    yield takeEvery(sagaActions.GET_VENDOR_LIST, updateVendorListSaga)
}
export function* updateTruckUnloadSummaryWatcher() {
    yield takeEvery(sagaActions.GET_TRUCK_UNLOAD_SUMMARY_LIST, updateTruckUnloadSummarySaga)
}
export function* updateTruckUnloadStatsWatcher() {
    yield takeEvery(sagaActions.GET_TRUCK_UNLOAD_STATS_LIST, updateTruckUnloadStatsSaga)
}
export function* updateScheduledLoadStatusWatcher() {
    yield takeEvery(sagaActions.GET_SCHEDULED_LOAD_STATUS_LIST, updateScheduledLoadStatusSaga)
}
export function* clearADFATWatcher() {
    yield takeEvery(sagaActions.CLEAR_ADFAT_REPORT_LIST, clearADFATSaga)
}
export function* selectedReportWatcher() {
    yield takeEvery(sagaActions.UPDATE_SELECTED_REPORT, updateSelectedReportSaga)
}
export function* clearTruckUnloadSummaryWatcher() {
    yield takeEvery(sagaActions.CLEAR_TRUCK_UNLOAD_LIST, clearTruckUnloadSummarySaga)
}
export function* clearTruckUnloadStatsWatcher() {
    yield takeEvery(sagaActions.CLEAR_TRUCK_UNLOAD_STATS_LIST, clearTruckUnloadStatsSaga)
}
export function* getTruckReportAndReceiptDetailsWatcher() {
    yield takeEvery(sagaActions.GET_TRUCK_REPORT_AND_RECEIPT_DETAILS, getTruckReportAndReceiptDetailsSaga)
}

export function* updateGateCheckReportWatcher() {
    yield takeEvery(sagaActions.GET_GATE_CHECK_REPORT_LIST, updateGateCheckReportSaga)
}

export function* clearGateCheckReportWatcher() {
    yield takeEvery(sagaActions.CLEAR_GATE_CHECK_REPORT_LIST, clearGateCheckReportSaga)
}
export function* getTruckReportAndReceiptEmailWatcher() {
    yield takeEvery(sagaActions.SEND_MAIL_FOR_TRUCK_RECEIPT, getTruckReportAndReceiptDetailsSaga)
}
export function* truckReportOperationObjWatcher() {
    yield takeEvery(sagaActions.UPDATE_REPORT_OPERATION_OBJECT, truckReportOperationObjSaga)
}
export function* clearTruckReportErrorWatcher() {
    yield takeEvery(sagaActions.CLEAR_REPORT_ERROR_OBJECT, clearTruckReportErrorSaga)
}
